import { useSelector } from 'react-redux'
import {
  getPageSizeDefault,
  isDefined as isDefinedSelector,
  getPageSizesAvailable,
  getHeaderLogo,
  getDefaultMetaData,
  getIsError,
  getStoreViewCode
} from 'lib/core/data/common/storeConfig/selectors'
import { RootState } from 'lib/core/data/reducer'

export const useStoreConfig = () => {
  const pageSizeDefault = useSelector(getPageSizeDefault)
  const isDefined = useSelector(isDefinedSelector)
  const pageSizesAvailable = useSelector(getPageSizesAvailable)
  const headerLogo = useSelector(getHeaderLogo)
  const defaultMetaData = useSelector(getDefaultMetaData)
  const isError = useSelector(getIsError)
  const storeViewCode = useSelector(getStoreViewCode)
  const pwaUrl = useSelector((state: RootState) => state.common.storeConfig.payload?.pwa_url)

  return {
    pageSizeDefault,
    pageSizesAvailable,
    pwaUrl,
    isDefined,
    headerLogo,
    defaultMetaData,
    isError,
    storeViewCode
  }
}
